import React from "react"
import { FaCheckCircle, FaInfoCircle } from "react-icons/fa"
import { ToggleLayer, Arrow } from "react-laag"

interface iInputLabel {
  label: string
  unit?: string | null
  hideUnit: boolean
  extendedInfo: string
}

const HelpToolTip: React.FC<{ text: string }> = ({ text }) => (
  <ToggleLayer
    renderLayer={({ isOpen, layerProps, arrowStyle, layerSide }) =>
      isOpen && (
        <div
          ref={layerProps.ref}
          className="layer rounded-lg text-xs shadow-lg p-2 px-4 bg-blue-700 text-blue-100"
          style={{
            ...layerProps.style,
            maxWidth: "200px",
          }}
        >
          {text}
          <Arrow
            style={arrowStyle}
            layerSide={layerSide}
            backgroundColor="#2b6cb0"
            roundness={0.5}
          />
        </div>
      )
    }
    closeOnOutsideClick
    placement={{
      autoAdjust: true,
      triggerOffset: 10,
    }}
  >
    {({ triggerRef, toggle }) => (
      <span
        className="cursor-pointer text-xl"
        ref={triggerRef}
        onClick={toggle}
      >
        <FaInfoCircle className="text-blue-700" />
      </span>
    )}
  </ToggleLayer>
)

const LabelUnit: React.FC<{ show: boolean; text?: string | null }> = ({
  show,
  text,
}) => {
  if (!show) return <FaCheckCircle className="text-base text-green-600 mx-2" />
  if (!text) return null
  return (
    <span
      className="block text-xs mx-2 tracking-wider font-normal bg-blue-700
                      text-blue-100 rounded-full uppercase px-2 leading-3 py-1"
    >
      {text}
    </span>
  )
}

const InputLabel: React.FC<iInputLabel> = ({
  label,
  unit,
  hideUnit,
  extendedInfo,
}) => {
  return (
    <p
      className="flex items-center justify-between
                  border-l-8 border-blue-700  py-1
                  text-xl sm:text-2xl font-thin
                  text-blue-700 bg-blue-100 px-4"
    >
      <span>{label}</span>
      <span className="flex items-center">
        <LabelUnit show={!hideUnit} text={unit} />
        <HelpToolTip text={extendedInfo} />
      </span>
    </p>
  )
}

export default InputLabel
